module.exports = __webpack_public_path__ + "img/slogan.f5160bdc.png";